import script from "./BlogPostDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostDetail.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostDetail.vue?vue&type=style&index=0&id=4aace1cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aace1cd"]])

export default __exports__